const FORM_SIZES = {
  sm: { height: 32, fontSize: 12, px: 1.25, iconSize: 14 },
  md: { height: 36, fontSize: 13, px: 1.5, iconSize: 16 },
  lg: { height: 40, fontSize: 14, px: 2, iconSize: 18 }
};
const FORM_DEFAULTS = {
  size: "md",
  radius: 2,
  popoverRadius: 3,
  // 12px
  focusRingWidth: 3
};
function createControlSx({
  gray,
  brand,
  size = FORM_DEFAULTS.size,
  radius = FORM_DEFAULTS.radius,
  fullWidth = false,
  error = false,
  disabled = false
}) {
  const s = FORM_SIZES[size];
  return {
    height: s.height,
    px: s.px,
    fontFamily: "inherit",
    fontSize: s.fontSize,
    fontWeight: 500,
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    borderRadius: radius,
    border: "1px solid",
    borderColor: error ? "error.main" : gray[300],
    backgroundColor: disabled ? gray[50] : gray[25],
    color: disabled ? gray[400] : gray[900],
    width: fullWidth ? "100%" : "fit-content",
    cursor: disabled ? "not-allowed" : "pointer",
    outline: "none",
    transition: "border-color 0.15s, box-shadow 0.15s",
    "&:hover": disabled ? {} : { borderColor: error ? "error.main" : brand[500] },
    "&:focus-visible": {
      borderColor: error ? "error.main" : brand[500],
      boxShadow: `0 0 0 ${FORM_DEFAULTS.focusRingWidth}px ${brand[50]}`
    }
  };
}
function createButtonSx({
  gray,
  brand,
  base,
  variant = "primary",
  size = FORM_DEFAULTS.size,
  radius = FORM_DEFAULTS.radius,
  fullWidth = false
}) {
  const s = FORM_SIZES[size];
  const common = {
    height: s.height,
    px: 2,
    fontSize: s.fontSize,
    fontWeight: 600,
    borderRadius: radius,
    width: fullWidth ? "100%" : void 0,
    textTransform: "none",
    transition: "all 0.12s",
    boxShadow: "none",
    "&:focus-visible": {
      boxShadow: `0 0 0 ${FORM_DEFAULTS.focusRingWidth}px ${brand[50]}`
    }
  };
  switch (variant) {
    case "primary":
      return {
        ...common,
        bgcolor: brand[600],
        color: "background.default",
        "&:hover": { bgcolor: brand[700], boxShadow: "none" },
        "&:disabled": { bgcolor: gray[200], color: gray[400] }
      };
    case "outline":
      return {
        ...common,
        bgcolor: "transparent",
        color: gray[600],
        border: `1px solid ${gray[300]}`,
        "&:hover": {
          borderColor: brand[700],
          color: brand[700],
          bgcolor: brand[25]
        },
        "&:disabled": { borderColor: gray[100], color: gray[400] }
      };
    case "secondary":
      return {
        ...common,
        bgcolor: gray[600],
        color: "background.default",
        "&:hover": { bgcolor: gray[700], boxShadow: "none" },
        "&:disabled": { bgcolor: gray[200], color: gray[400] }
      };
    case "ghost":
      return {
        ...common,
        bgcolor: "transparent",
        color: gray[700],
        "&:hover": { bgcolor: gray[50] },
        "&:disabled": { color: gray[400] }
      };
  }
}
function createInputFieldSx({
  gray,
  brand,
  size = FORM_DEFAULTS.size,
  radius = "8px",
  error = false
}) {
  const s = FORM_SIZES[size];
  const py = size === "sm" ? "6px" : size === "lg" ? "10px" : "8px";
  return {
    "& .MuiInputBase-input": {
      fontSize: s.fontSize,
      py,
      px: "12px",
      lineHeight: "18px"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? "error.main" : brand ? brand[500] : gray[700]
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? "error.main" : gray[300],
      borderRadius: radius
    }
  };
}
function createPaperSx({
  gray,
  radius = FORM_DEFAULTS.popoverRadius
}) {
  return {
    borderRadius: radius,
    border: `1px solid ${gray[100]}`,
    boxShadow: `0 4px 12px ${gray[100]}`,
    overflow: "hidden"
  };
}
function createLabelSx({ gray, error = false }) {
  return {
    fontSize: 12,
    fontWeight: 500,
    color: error ? "error.main" : gray[600],
    whiteSpace: "nowrap"
  };
}
export {
  FORM_DEFAULTS,
  FORM_SIZES,
  createButtonSx,
  createControlSx,
  createInputFieldSx,
  createLabelSx,
  createPaperSx
};
